import React, {useState, useEffect, useRef} from 'react';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';
import _ from 'lodash';
import {Form, Input, Select, Spin, notification, DatePicker} from 'antd';
import {Modal, Button} from 'react-bootstrap';
import moment from 'moment';
import {toast} from 'react-toastify';
import 'moment/locale/vi';
import locale from 'antd/es/date-picker/locale/vi_VN';
import * as actionsModal from 'src/setup/redux/modal/Actions';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import {useAuth} from '../../../modules/auth';

import {
  requestPOST,
  requestPOST_NEW,
  requestGET,
  requestPUT_NEW,
  API_URL,
  FILE_URL,
} from 'src/utils/baseAPI';
import {handleImage} from 'src/utils/utils';
import ImageUpload from 'src/app/components/ImageUpload';

const ChangePassword = () => {
  const {currentUser} = useAuth();
  const {token} = authHelper.getAuth();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [loadding, setLoadding] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [error, setEror] = useState(null);

  const handleOk = async () => {
  const formData = form.getFieldsValue(true);
    
    setButtonLoading(true);
    try {
      formData.type = 1;
      const res =  await requestPUT_NEW(`api/personal/change-password`, formData)
    if (res.status === 200) {
      toast.success('Đổi mật khẩu thành công!');
      form.resetFields();
    } else {
      //toast.error('Thất bại, vui lòng thử lại!');
      const errors = Object.values(res?.data?.errors ?? {});
      let final_arr = [];
      errors.forEach((item) => {
        final_arr = _.concat(final_arr, item);
      });
      console.log(final_arr);
      toast.error('Thất bại, vui lòng thử lại! ' + final_arr.join(' '));
    }

    }
    catch(err){

    }
    setButtonLoading(false)

  };

  return (
    <>
    <div class="card-header cursor-pointer "><div class="card-title m-0"><h3 class="fw-bold m-0">Đổi mật khẩu</h3></div></div>
      <Form form={form} layout='vertical' /* initialValues={initData} */ autoComplete='off' className='p-9'>
        <div className='row '>
          <div className='col-xl-6'>
            <FormItem
              label='Mật khẩu đăng nhập cũ'
              name='password'
              rules={[
                {required: true, message: 'Không được để trống!'},
                {
                  pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
                  message: 'Mật khẩu phải hơn 8 kí tự, chứa ít nhât 1 chữ thường, In hoa và kí tự đặc biệt',
                },
              ]}
            >
              <Input placeholder='nhập mật khẩu cũ' type='password' />
            </FormItem>
          </div>
          </div>
          <div className='row '>

          <div className='col-xl-6'>
            <FormItem
              label='Mật khẩu đăng nhập mới '
              name='newPassword'
              rules={[
                {required: true, message: 'Không được để trống!'},
                {
                  pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
                  message: 'Mật khẩu phải hơn 8 kí tự, chứa ít nhât 1 chữ thường, In hoa và kí tự đặc biệt',
                },
              ]}
            >
              <Input placeholder='nhập mật khẩu mới' type='password' />
            </FormItem>
          </div>
          </div>
          <div className='row '>

          <div className='col-xl-6'>
            <FormItem
              label='Nhập lại mật khẩu đăng nhập mới'
              dependencies={['newPassword']}
              name='confirmNewPassword'
              rules={[
                {required: true, message: 'Không được để trống!'},
                ({getFieldValue}) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('mật khẩu mới không khớp'));
                  },
                }),
              ]}
            >
              <Input placeholder='nhập lại mật khẩu mới' type='password' />
            </FormItem>
          </div>
        </div>
        <span className='fs-5 fw-semibold text-danger pb-5 d-block'>{error}</span>
      </Form>
      <div className='card-footer d-flex justify-content-end py-6 px-9'>
        <button
          type='button'
          className='btn btn-primary'
          id='kt_account_profile_details_submit'
          onClick={handleOk}
          disabled={buttonLoading}
        >
          Lưu thay đổi
        </button>
      </div>
    </>
  );
};

export default ChangePassword;
